import loginedApi from "../apis";
import {
  INTERBRANCH_PATIENT_DETAILS,
  INTERBRANCH_CLINIC_SPECIALITY,
  INTERBRANCH_CONSULTATION,
  INTERBRANCH_REGISTER_PATIENT,
  INTERBRANCH_READ_PATIENT_PROFILE,
  INTERBRANCH_CLINIC_SPECIALITY_DOCTORLIST,
  INTERBRANCH_UPDATE_PATIENT_BASICINFO,
  INTERBRANCH_INSERT,
  INTERBRANCH_APPOINTMENT_HISTORY,
  INTERBRANCH_STORE_APPOINMENT_FORM_DATA,
  INTERBRANCH_DETAILED_CONSULTATION,
  INTERBRANCH_COUPON_VERIFICATION,
  INTERBRANCH_UPLOAD_REPORTS,
  INTERBRANCH_UPLOAD_REPORTS_UPDATE,
  INTERBRANCH_UPDATE_LIFESTYLE_PREEXISTING_INFO,
  INTERBRANCH_UPDATE_MEDIACATION_ALLERGY_INFO,
  INTERBRANCH_APPOINTMENT_STATUS,
  INTERBRANCH_MODAL_UPDATE,
  INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM
} from "./type";
import { INTERBRANCH_COORDINATOR, PATIENT } from "../constants/const";
import { ADD_DATA_TO_ALLERGY_MEDICATION_REDUX, CLEAR_INTERBRANCH_DATA, REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX } from "../Helpers/InterBranchConstants";
import { validateIsEmpty } from "../Helpers/Constants";
import moment from "moment";
import axios from "axios";
import CryptoJS from "crypto-js";
  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

let platform = window.navigator.platform;
let userAgent = window.navigator.userAgent;
let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`



//This is used to store the form data
export const Store_formData = (data) => async (dispatch) => {
  dispatch({ type: INTERBRANCH_STORE_APPOINMENT_FORM_DATA, payload: data });
  return true
};


//This API call is used to fetch the Clinic Speciality Details from DB
export const fetch_clinic_speciality = (clinicId) => async (dispatch) => {
  //console.log("Inside fetch_clinic_speciality")
  let resp = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { "browserTimeZone": `GMT${formatTime}` },
      "requestType": 1058
    });

  const countrycode = resp.data.data;

  let data = {
    clinicId: clinicId,
    accessCountry: countrycode.Country,
    browserTimeZone: `GMT${formatTime}`
  }
  const response = await loginedApi.post("getclinicspeciality", {
    requestType: 507,
    token :hashcode.toString(),
    data
  });

  //console.log("Clinic Speciality fetched from fetch_clinic_speciality API!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_CLINIC_SPECIALITY, payload: response.data });
  }
};


//This API call is used to fetch the consultation Details from DB
export const fetch_consultationNow = (userId) => async (dispatch) => {
  //   //console.log("Inside fetch_consultation")

  let data = {
    userId: userId,
    userType: INTERBRANCH_COORDINATOR,
    browserTimeZone: `GMT${formatTime}`
  }

  const response = await loginedApi.post("consultation", {
    requestType: "201",
    token :hashcode.toString(),
    data
  });
  if (response.status === 200) {
    return response.data;
  }
};
//   //console.log("Consultation data fetched from Consultation API!!!", response);
//   if (response.status === 200) {
//     dispatch({ type: INTERBRANCH_CONSULTATION, payload: response.data });
//   }
// };

//This API call is used to register patient data in the DB
export const registerPatient = (clinicId, appointment_form) => async (dispatch) => {


  let resp = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { "browserTimeZone": `GMT${formatTime}` },
      "requestType": 1058
    });

  const countrycode = resp.data.data;
  var hash = CryptoJS.SHA512("C2MD|Welcome@123");

  let data = {
    userType: PATIENT,
    firstName: appointment_form?.patientName,
    lastName: "",
    mobile: appointment_form?.patientNumber?.numberWithCode && `%2b${appointment_form?.patientNumber?.numberWithCode}`,
    password: hash.toString(),
    aadhaarNumber: appointment_form?.aadhaarNumber,
    emailId: appointment_form?.emailID ? appointment_form?.emailID : "",
    emergencyContactName: appointment_form?.emergencyContactName,
    hospitalId: appointment_form?.patientHospitalId,
    emergencyContactNumber: appointment_form?.emergencyContactNumber?.numberWithCode && `%2b${appointment_form?.emergencyContactNumber?.numberWithCode}`,
    patienttimezone: `GMT${formatTime}`,
    signupFrom: "C2MD",
    accessCountry: countrycode.Country,
    clinicId: clinicId,
    gender: appointment_form?.gender,
    type: "signUpByMobile"
  }


  //console.log("appointment_form", appointment_form);
  //console.log( "registerpatient data",{data} );

  const response = await loginedApi.post("registerpatient", {
    requestType: "71",
    token :hashcode.toString(),
    data
  });

  //console.log("Patient registered through registerpatient API and patient id generated!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_REGISTER_PATIENT, payload: response.data });
    console.log("registerpatient response :", response.data);
    return response.data

  }
};

//This API call is used to fetch the Patient Details from DB
export const fetch_patients_details = (doctorId, patientId, appointment_form, submissiondata) => async (dispatch) => {
  //console.log("Inside fetch_patients_details")

  let data = {
    doctorId: submissiondata?.chosendoctorId,
    patientId: patientId,
    browserTimeZone: `GMT${formatTime}`
  }
  const response = await loginedApi.post("getmypatient",
    {
      requestType: "108",
      token :hashcode.toString(),
      data
    }
  );

  //console.log("PATIENT's data fetched from getmypatient API!!!", response);
  if (response.status === 200) {


    let rawData = response?.data?.data?.patientDetails


    let dataToForm = {
      ...appointment_form,
      ...submissiondata,
      heightValue: rawData?.basicInfo?.heightValue,
      heightMeasurement: rawData?.basicInfo?.heightMeasurement,
      weightValue: rawData?.basicInfo?.weightValue,
      weightMeasurement: rawData?.basicInfo?.weightMeasurement,
      bmiValue: rawData?.basicInfo?.bmiValue,
      bloodGroup: rawData?.basicInfo?.bloodGroup,
      lmp: rawData?.basicInfo?.lmp,

      bloodPressurSystolic: rawData?.basicInfo?.bloodpressure?.split("|")[0],
      bloodPressurDiastolic: rawData?.basicInfo?.bloodpressure?.split("|")[1],
      bloodPressurunit: rawData?.basicInfo?.bloodpressureMeasurement,
      bloodpressureMeasurementDate: rawData?.basicInfo?.bloodpressureMeasurementDate,

      bodyTempratureValue: rawData?.basicInfo?.bodytemprature,
      bodytempratureMeasurement: rawData?.basicInfo?.bodytempratureMeasurement,
      bodytempratureMeasurementDate: rawData?.basicInfo?.bodytempratureMeasurementDate,
      bodyTempraturePosition: rawData?.basicInfo?.bodytempraturePosition,

      PulseRateValue: rawData?.basicInfo?.pulserate,
      PulseRateUnit: rawData?.basicInfo?.pulserateMeasurement,
      pulserateMeasurementDate: rawData?.basicInfo?.pulserateMeasurementDate,
      PulseRatePosition: rawData?.basicInfo?.pulserateMeasurementPosition,

      RespirationValue: rawData?.basicInfo?.Respiration,
      RespirationUnit: rawData?.basicInfo?.RespirationMeasurement,
      RespirationMeasurementDate: rawData?.basicInfo?.RespirationMeasurementDate,

    }

    if (rawData?.basicInfo?.patientAllergies) {
      // console.log("Allergies: ",rawData?.basicInfo?.patientAllergies)
      dataToForm["allergies"] = rawData?.basicInfo?.patientAllergies
    }
    if (rawData?.medicalHistory?.patientMedication) {
      // console.log("Medications:",rawData?.medicalHistory?.patientMedication)
      dataToForm["medications"] = rawData?.medicalHistory?.patientMedication
    }

    if (rawData?.basicInfo?.patientLifeStyles) {
      dataToForm["patientLifeStyles"] = rawData?.basicInfo?.patientLifeStyles
    }
    if (rawData?.medicalHistory?.patientPreExistingConditions) {
      dataToForm["patientPreExistingConditions"] = rawData?.medicalHistory?.patientPreExistingConditions
    }

    // console.log("TestData...",dataToForm );


    dispatch({ type: INTERBRANCH_STORE_APPOINMENT_FORM_DATA, payload: dataToForm })

    dispatch({ type: INTERBRANCH_PATIENT_DETAILS, payload: response.data });

  }
};

//This API call is used to read patient profile from DB
export const read_patient_profile = (patientId) => async (dispatch) => {
  //console.log("Inside read_patient_profile")

  let data = {
    patientId: patientId,
    browserTimeZone: `GMT${formatTime}`,
    isEditProfile: true
  }
  const response = await loginedApi.post("profile", {
    requestType: "52",
    token :hashcode.toString(),
    data
  });

  //console.log("Read Patient's data from profile API!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_READ_PATIENT_PROFILE, payload: response.data });
  }
};

//This API call is used to fetch the clinic speciality doctor list from DB
export const fetch_clinic_speciality_doctor_list = (clinicId, speciality) => async (dispatch) => {
  //console.log("Inside fetch_clinic_speciality_doctor_list")
  let resp = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { "browserTimeZone": `GMT${formatTime}` },
      "requestType": 1058
    });
  const countrycode = resp.data.data;
  let data = {
    Ipaddress: countrycode.Ipaddress,
    useragent: userAgent,
    todayRate: "74.27006",
    currency: countrycode.currency,
    clinicId: clinicId,
    browserTimeZone: `GMT${formatTime}`,
    Os: platform,
    City: "",
    doctorId: "",
    accessCountry: countrycode.Country,
    speciality: speciality
  }
  const response = await loginedApi.post("getclinicdoctorbyspecialitywithstatus", {
    requestType: "578",
    token :hashcode.toString(),
    data
  });

  //console.log("Fetched ClinicSpeciality Dr List data from getclinicdoctorbyspecialitywithstatus API!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_CLINIC_SPECIALITY_DOCTORLIST, payload: response.data });
    return true
  }
};

//This API call is used verify the coupon code
export const fetch_services = (couponCode, doctorId) => async (dispatch) => {
  //console.log("Inside fetch_services")
  let resp = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { "browserTimeZone": `GMT${formatTime}` },
      "requestType": 1058
    });
  const countrycode = resp.data.data;

  let data = {
    couponCode: couponCode,
    doctorId: doctorId,
    accessCountry: countrycode.Country,
    fees: "INR 0.00",
    todayRate: ""
  }
  const response = await loginedApi.post("services", {
    requestType: "172",
    token :hashcode.toString(),
    data
  });

  //console.log("Fetched services from services API!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_COUPON_VERIFICATION, payload: response.data });
  }
};

//This API call is used to update the patient's basic info in the DB
export const update_patient_vital_info = (patientId, appointmentDetails) => async (dispatch) => {
  //console.log("Inside update_patient_vital_info")
  //console.log("AppointmentDetails :", appointmentDetails)

  console.log(appointmentDetails);

  let data = {
    patientId: patientId,
    type: "VitalSign",
    patientBasicInfo: {
      bloodGroup: appointmentDetails.bloodGroup,
      weightValue: appointmentDetails.weightValue,
      weightMeasurement: appointmentDetails.weightMeasurement,
      heightValue: appointmentDetails.heightValue,
      heightMeasurement: appointmentDetails.heightMeasurement,
      lmp: appointmentDetails.lmp,
      bmiValue: appointmentDetails.bmiValue,

      bloodpressure: validateIsEmpty(appointmentDetails.bloodPressurSystolic) + "|" + validateIsEmpty(appointmentDetails.bloodPressurDiastolic),
      bloodpressureMeasurement: "mmHG",
      bloodpressureMeasurementDate: appointmentDetails.bloodpressureMeasurementDate,

      bodytemprature: appointmentDetails.bodyTempratureValue,
      bodytempratureMeasurement: appointmentDetails.bodytempratureMeasurement,
      bodytempratureMeasurementDate: appointmentDetails.bodytempratureMeasurementDate,
      bodytempraturePosition: appointmentDetails.bodyTempraturePosition,

      pulserate: appointmentDetails.PulseRateValue,
      pulserateMeasurement: "Beats/Min",
      pulserateMeasurementDate: appointmentDetails.pulserateMeasurementDate,
      pulserateMeasurementPosition: appointmentDetails.PulseRatePosition,

      respiration: appointmentDetails.RespirationValue,
      respirationMeasurement: "Beats/Min",
      respirationMeasurementDate: appointmentDetails.pulserateMeasurementDate,
      profileType: "patientProfile",
      familyMemberId: ""
    },
    browserTimeZone: `GMT${formatTime}`,
  }


  console.log("Printing Vitals Data: ", data)

  const response = await loginedApi.post("profile", {
    requestType: "83",
    token :hashcode.toString(),
    data
  });

  //console.log( "Updated Patient Vital Info using profile API!!!" ,response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_UPDATE_PATIENT_BASICINFO, payload: response.data });
  }
};


//This API call is used to update the patient's lifestyle and pre-existing info in the DB
export const update_lifestyle_preexisting_conditions_info = (patientId, appointmentDetails) => async (dispatch) => {
  console.log("Inside update_lifestyle_preexisting_conditions_info")
  console.log("AppointmentDetails :", appointmentDetails)
  let data = {
    patientId: patientId,
    type: "preExistingConditions",
    patientMedicalInfo: {
      patientPreExistingConditions: appointmentDetails.patientPreExistingConditions,
      lifeStyles: appointmentDetails.patientLifeStyles,
      profileType: "patientProfile",
      familyMemberId: ""
    },

    browserTimeZone: `GMT${formatTime}`,
  }
  //console.log("Printing Lifestyle Data: ", data);
  const response = await loginedApi.post("profile", {
    requestType: "84",
    token :hashcode.toString(),
    data
  });

  //console.log( "Updated Patient LifeStyle and Pre-Existing Conditions Info using profile API!!!" ,response);
  if (response.status === 200) {

    console.log(response.data.data);

    dispatch({ type: INTERBRANCH_UPDATE_LIFESTYLE_PREEXISTING_INFO, payload: response.data });

    dispatch({
      type: INTERBRANCH_STORE_APPOINMENT_FORM_DATA, payload: {
        patientLifeStyles: response?.data?.data?.patientMedicalInfo?.lifeStyles,
        patientPreExistingConditions: response?.data?.data?.patientMedicalInfo?.patientPreExistingConditions,
      }
    });


  }
};


//This API call is used to update the patient's lifestyle and pre-existing info in the DB
export const update_allergy_medication_info = (patientId, allergies, medication) => async (dispatch) => {
  //console.log("Inside update_allergy_medication_info")
  console.log("Allergy & Medication:", allergies, medication)
  let data = {
    patientId: patientId,
    type: "AllergiesMedications",
    patientMedicalInfo: {
      patientMedication: medication,
      allergies: allergies,
      profileType: "patientProfile",
      familyMemberId: ""
    },

    browserTimeZone: `GMT${formatTime}`,
  }
  //console.log("Printing Allergy & Medication Data: ", data);
  const response = await loginedApi.post("profile", {
    requestType: "85",
    token :hashcode.toString(),
    data
  });



  console.log( "Updated Patient LifeStyle and Pre-Existing Conditions Info using profile API!!!" ,response);

  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_UPDATE_MEDIACATION_ALLERGY_INFO, payload: response.data });


    dispatch({
      type: INTERBRANCH_STORE_APPOINMENT_FORM_DATA, payload: {
        allergies: response?.data?.data?.patientMedicalInfo?.allergies,
        medications: response?.data?.data?.patientMedicalInfo?.patientMedication,
      }
    });

  }
};


//This API call is used to pass the patient's appointment details into  DB
export const insert_inter_branch = (
  patientId, partnerid, hospitalId, typeOfConsultation, mobilenumber, doctorId, couponCode) => async (dispatch) => {
    //console.log("Inside insert_inter_branch")

    let data = {
      patientId: patientId,
      partnerid: partnerid,
      hospitalId: hospitalId,
      couponcode: couponCode,
      typeofconsultation: typeOfConsultation,
      mobilenumber: mobilenumber,
      doctorId: doctorId,
      browserTimeZone: `GMT${formatTime}`,
      attachedReportFiles: []
    }
    const response = await loginedApi.post("inserinterbranch", {
      requestType: "178",
      token :hashcode.toString(),
      data
    });

    return response.data

    // if (response.status === 200) {
    //   dispatch({ type: INTERBRANCH_INSERT, payload: response.data });
    // }
  };

//This API call is used to fetch the appointment history
export const fetch_interbranch_appointment_history = (coordinatorId, dateObject) => async (dispatch) => {
  //console.log("Inside fetch_interbranch_appointment_history")

  // let data = {
  //   doctorId: coordinatorId,
  //   operationDate: "2022/05/22",
  //   operation: "find",
  //   browserTimeZone: "GMT+05:30",
  //   startDate: "15-Sep-2022",
  //   endDate: "15-Sep-2022"
  // }

  //operation - "find" will fetch the record of only one given date (startDate)
  //operation - "start" will fetch the records of 10 dates starting from current date
  //operation - "next/previous" will fetch the records of the given date range from start to end - 10 records per fetch

  // {
  //     "requestType": "507",
  //     "token": "C2MDVerificationToken",
  //     "data": {
  //         "doctorId": "71851731",
  //         "operationDate": "2022/05/22",
  //         "operation": "start",//find, next,previous
  //         "browserTimeZone": "GMT+05:30",
  //         "startDate": "27-May-2022",
  //         "endDate": "27-May-2022"
  //     }
  // }

  // if(dateObject.date)
  // {
  //   data["operation"]="start"
  //   data["operationDate"]=dateObject?.date
  // }
  // else{
  //   data["operation"]="find"
  //   data["startDate"]=dateObject?.fromDate
  //   data["endDate"]=dateObject?.toDate
  // }

  // console.log(data);

  // const response = await loginedApi.post("getinterbranchappointmenthistory", {
  //   requestType: "189", 109
  //   token :hashcode.toString(),
  //   data
  // });
  let date = moment(new Date()).format("MMM DD YYYY HH:MM:SS ")
  const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Friday", "Saturday"];
  let day = week[moment().day()];
  const res = await loginedApi.post("getinterbranchappointmenthistory", {
    token :hashcode.toString(),
    data: {
      doctorId: coordinatorId,
      operation: "start",
      browserTimeZone: `GMT${formatTime}`,
      // operationDate: "Thu Sep 15 2022 09:30:30 GMT+0530(Indian Standard Time)",   
      operationDate: `${day} ${date} GMT+0530(Indian Standard Time)`,
    },
    "requestType": 189,
  }
  );

  console.log("Appointment Details fetched from getInterbranchappointmenthistory API!!!", res);
  if (res.status === 200) {
    dispatch({ type: INTERBRANCH_APPOINTMENT_HISTORY, payload: res.data.data });
  }
};


//This API call is used to fetch detailed consultation from DB
export const fetch_detailed_consultation = () => async (dispatch) => {
  //console.log("Inside fetch_detailed_consultation")

  let data = {
    consultationId: "",
    userType: INTERBRANCH_COORDINATOR,
    browserTimeZone: `GMT${formatTime}`,
    todayRate: "73.00",
    currency: "",
    userId: "",
    Ipaddress: "",
    useragent: "",
    Browser: "",
    Os: "",
    accessCountry: "",
    loginId: "",
    sessioninfo: {
      browserTimeZone: `GMT${formatTime}`,
      clinicId: "",
      clinicLogo: "",
      clinicname: "",
      clinicpayment_gateway_name: "",
      clinicpayment_gateway_salt: "",
      clinicpayment_gateway_secret_key: "",
      clinicpayment_gateway_type: "",
      country: "",
      coverImage: "",
      fromMobile: "",
      gender: "",
      hashPassword: {
        //Check and update
      },
      isInterbranch: "",
      isallegiesavailable: "",
      ismedicationavailable: "",
      livenowstatus: "",
      loginFrom: "",
      loginType: "",
      mobileNumber: "",
      password: "",
      privilegeList: "",
      profileId: "",
      profileImage: "",//https://uat.c2mdr.com/demo/ImageRequestServlet/profile/93579795.jpg?_=1616067571497
      profileName: "",
      profileStatus: "",
      socialProfileId: "",
      timezone: "GMT+05:30",
      userId: "",
      userName: "",
      userType: INTERBRANCH_COORDINATOR
    }
  }
  const response = await loginedApi.post("consultation", {
    requestType: "400",
    token :hashcode.toString(),
    data
  });

  //console.log("Detailed Consultation fetched from consultation API!!!", response);
  if (response.status === 200) {
    dispatch({ type: INTERBRANCH_DETAILED_CONSULTATION, payload: response.data });
  }
};

export const uploadReports = ({ files, name, prevReports }) => async (dispatch) => {

  let reportsToBe = prevReports ?
    [...prevReports, {
      file: files,
      name: name
    }]
    :
    [{
      file: files,
      name: name
    }]

  console.log("INTERBRANCH_UPLOAD_REPORTS", files, name);

  if (files) {
    dispatch({
      type: INTERBRANCH_UPLOAD_REPORTS, payload: reportsToBe
    });

  }
}

export const RemoveUploadedReport = (file, reportsUploaded) => async (dispatch) => {




  axios
    .post(
      "https://www.connect2mydoctor.com/c2mydrrestganga/v1/c2mdapi/removereports",

      {
        requestType: 596,
        token :hashcode.toString(),
        data: { filename: file?.name },
      }
    )
    .then((res) => {

      let filteredArray = reportsUploaded.filter(element => element.name != file?.name)

      dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: filteredArray });


    })
    .catch((error) => { });






}


export const addDataToAllergyMedicationTable = (payloadData) => async (dispatch) => {

  dispatch({ type: ADD_DATA_TO_ALLERGY_MEDICATION_REDUX, payload: payloadData });

  // dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: filteredArray });
}

export const removeDataToAllergyMedicationTable = (payloadData) => async (dispatch) => {

  dispatch({ type: REMOVE_DATA_FROM_ALLERGY_MEDICATION_REDUX, payload: payloadData });

  // dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: filteredArray });

}


export const clearInterbranchData = (payloadData) => async (dispatch) => {

  console.log("Clearing interbranch data........................",);

  dispatch({ type: CLEAR_INTERBRANCH_DATA });

  // dispatch({ type: INTERBRANCH_UPLOAD_REPORTS_UPDATE, payload: filteredArray });



}


//This API call is used to book an appointment for the patient in Scheduled Mode
export const book_appointment = (
  patientId, partnerid, doctorId, typeOfConsultation, couponCode, chosenTime, chosenDate, appointmentDetails) => async (dispatch) => {
    console.log("Inside book_appointment", appointmentDetails)
 
    let reportsArray = []

    if (appointmentDetails?.reportsUploaded && appointmentDetails?.reportsUploaded.length > 0) {
      appointmentDetails?.reportsUploaded.map((each) => {
        reportsArray.push(each?.name)
      })
    }
    console.log("Report Names:",reportsArray)


    let data = {
      patientId: patientId,
      doctorId: doctorId,
      partnerid: partnerid,
      hospitalId: appointmentDetails?.patientHospitalId ? appointmentDetails?.patientHospitalId : "",
      couponcode: couponCode,
      typeofconsultation: typeOfConsultation,
      browserTimeZone: `GMT${formatTime}`,
      appointmedate: moment(chosenDate).format("DD-MMM-YYYY"),
      appointmenttime: chosenTime,
      mobilenumber: appointmentDetails?.patientNumber?.numberWithCode ? `%2b${appointmentDetails?.patientNumber?.numberWithCode}` : "",
      reports: reportsArray.join('')
    }


    // for (var pair of formData.entries()) {
    //   console.log(pair[0] + ', ' + pair[1]);
    // }

    let config = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }


    const response = await loginedApi.post("coordinatorappointmentbooking", {
      requestType: "187",
      token :hashcode.toString(),
      data
    });

    console.log("Appointment Booking API's response!!!", response);
    if (response.status === 200) {
      dispatch({ type: INTERBRANCH_APPOINTMENT_STATUS, payload: response.data });
      return ({ status: true })
    }
    else {
      return ({ status: false })
    }
  };



export const show_common_alert = ({ message }) => async (dispatch) => {

  dispatch({
    type: INTERBRANCH_MODAL_UPDATE,
    payload: { modalName: "commomAlertModal", isVisible: true, data: message }
  })

};

//This function is used to fetch the patient's basic details, once the OTP is verified
export const fetchPatientPrimaryDetails =
  ({ searchtype, searchKey, appointment_form }) =>
    async (dispatch) => {
      console.log("Appointment Form:", appointment_form)
      const res = await loginedApi.post("coordinatorfetchpatientdetails", {
        requestType: 86,
        token :hashcode.toString(),
        data: { searchtype: searchtype, searchKey: searchKey },
      });

      if (res.status === 200) {

        console.log("Response from coordinatorfetchpatientdetails", res)

        let rawData = res?.data?.data;
        let dataToForm = {
          ...appointment_form,
          patientName: rawData?.fullname,
          patientNumber: {
            number: searchKey.split(' ')[1],
            countryCode: searchKey.split(' ')[0]
          },
          emailID: rawData?.emailID,
          gender: rawData?.gender,
          patientHospitalId: rawData?.hospitalid,
          aadhaarNumber: rawData?.aadharnumber,
          emergencyContactName: rawData?.emergencyname,
          emergencyContactNumber: rawData?.emergencynumber ? {
            number: rawData?.emergencynumber?.split(' ')[1],
            countryCode: rawData?.emergencynumber?.split(' ')[0]
          } : undefined
        }
        dispatch({ type: INTERBRANCH_UPDATE_TEMP_APPOINTMENT_FORM, payload: dataToForm });

        return rawData
      }
    };


//This API call is used to book an appointment for the patient in Scheduled Mode
export const book_Videoconsultaton = (
  patientId, partnerid, doctorId, typeOfConsultation, couponCode, appointmentDetails) => async (dispatch) => {
    console.log("Inside book_appointment", appointmentDetails)

    let reportsArray = []

    if (appointmentDetails?.reportsUploaded && appointmentDetails?.reportsUploaded.length > 0) {
      appointmentDetails?.reportsUploaded.map((each) => {
        reportsArray.push(each?.name)
      })
    }

    let data = {
      patientId: patientId,
      doctorId: doctorId,
      partnerid: partnerid,
      hospitalId: appointmentDetails?.patientHospitalId ? appointmentDetails?.patientHospitalId : " ",
      couponcode: couponCode,
      typeofconsultation: typeOfConsultation,
      browserTimeZone: `GMT${formatTime}`,
      mobilenumber: appointmentDetails?.patientNumber?.numberWithCode ? `%2b${appointmentDetails?.patientNumber?.numberWithCode}` : " ",
      attachedReportFiles:reportsArray.join('')
    }

    const response = await loginedApi.post("inserinterbranch", {
      requestType: "178",
      token :hashcode.toString(),
      data
    });

    console.log("Consultation API's response!!!", response);
    return response.data
  };